<template>
  <div class="cup">
    <svg
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.9449 29.3262L37.1045 30.6188V37.9279C37.1045 38.3373 37.5667 38.5759 37.9004 38.3389L40.6579 36.3799C40.8327 36.2557 41.0669 36.2557 41.2417 36.3799L43.9992 38.3389C44.3329 38.576 44.7951 38.3373 44.7951 37.9279V24.9874L43.307 24.8472C41.803 27.1896 38.7412 29.0017 37.9449 29.3262Z"
        fill="#FF5876"
      />
      <path
        d="M37.1045 28.7918V30.6189C37.912 30.292 38.6882 29.8974 39.4293 29.4323C41.4924 28.1378 43.5505 26.6345 44.7951 24.9876V22.123L37.1045 28.7918Z"
        fill="#E6485D"
      />
      <path
        d="M48.2673 7.44717C47.5957 6.65654 46.6155 6.20312 45.578 6.20312H41.4745L40.1323 7.06943L39.8387 8.32012L40.7459 9.22734H45.5779C45.7811 9.22734 45.906 9.33867 45.9622 9.40508C46.0187 9.47139 46.1082 9.61269 46.0753 9.81309C45.6879 12.1747 44.6774 16.6997 42.2616 20.4711C40.7508 22.8298 38.9148 24.5485 36.7718 25.6182L34.5631 27.6979L34.3325 29.6252C36.1569 29.258 37.852 28.5874 39.3979 27.6174C41.4812 26.3102 43.3015 24.4546 44.8081 22.1022C47.3812 18.0854 48.5403 13.4685 49.0596 10.3025C49.2277 9.27861 48.9389 8.23789 48.2673 7.44717Z"
        fill="#FF9517"
      />
      <path
        d="M38.9316 9.22734H40.7462L41.4747 6.20312H39.6602L38.3887 7.71523L38.9316 9.22734Z"
        fill="#EF7F0F"
      />
      <path
        d="M34.6556 26.4353L32.7041 27.8987L32.2202 29.9103C32.9421 29.8582 33.6461 29.7614 34.3325 29.6232C35.4323 28.524 36.2812 27.1615 36.7717 25.6172C36.0966 25.9542 35.3912 26.2275 34.6556 26.4353Z"
        fill="#EF7F0F"
      />
      <path
        d="M40.998 2.72178H10.0331C9.03092 2.72178 8.30709 1.17353 8.46178 0.906445C8.77564 0.364551 9.36177 0 10.0331 0H40.998C41.6693 0 42.2554 0.364551 42.5693 0.906445C42.724 1.17353 42.0002 2.72178 40.998 2.72178Z"
        fill="#FF9517"
      />
      <path
        d="M40.9978 1.81445H10.0328C9.36152 1.81445 8.77686 1.44902 8.46299 0.907227C8.3083 1.17432 8.21826 1.48359 8.21826 1.81445C8.21826 2.8166 9.03066 3.629 10.0328 3.629H40.9978C41.9999 3.629 42.8123 2.8166 42.8123 1.81445C42.8123 1.48359 42.7223 1.17432 42.5676 0.907227C42.2536 1.44902 41.6689 1.81445 40.9978 1.81445Z"
        fill="#EF7F0F"
      />
      <path
        d="M13.0548 29.3257L13.8952 30.6184V37.9274C13.8952 38.3368 13.433 38.5754 13.0993 38.3384L10.3418 36.3794C10.167 36.2552 9.93281 36.2552 9.75801 36.3794L7.00049 38.3384C6.6668 38.5755 6.20459 38.3368 6.20459 37.9274V24.9869L7.69268 24.8467C9.19678 27.1892 12.2585 29.0012 13.0548 29.3257Z"
        fill="#FF5876"
      />
      <path
        d="M13.8952 28.7913V30.6185C13.0877 30.2915 12.3115 29.8969 11.5704 29.4318C9.50732 28.1373 7.44932 26.634 6.20459 24.9871V22.1226L13.8952 28.7913Z"
        fill="#E6485D"
      />
      <path
        d="M2.73234 7.44717C3.40392 6.65654 4.38409 6.20312 5.42159 6.20312H9.52511L10.8673 7.06943L11.1609 8.32002L10.2536 9.22725H5.42159C5.21847 9.22725 5.09357 9.33857 5.03722 9.40498C4.98077 9.47129 4.89122 9.6126 4.92413 9.81299C5.31154 12.1746 6.32199 16.6996 8.73781 20.471C10.2486 22.8297 12.0846 24.5484 14.2276 25.6181L16.4363 27.6979L16.6669 29.6251C14.8425 29.2579 13.1475 28.5873 11.6016 27.6173C9.51827 26.3101 7.69796 24.4545 6.19132 22.1021C3.61818 18.0853 2.45909 13.4684 1.93986 10.3024C1.77189 9.27861 2.06075 8.23789 2.73234 7.44717Z"
        fill="#FF9517"
      />
      <path
        d="M12.068 9.22734H10.2534L9.5249 6.20312H11.3395L12.6109 7.71523L12.068 9.22734Z"
        fill="#EF7F0F"
      />
      <path
        d="M16.3441 26.4353L18.2956 27.8987L18.7795 29.9103C18.0575 29.8582 17.3536 29.7614 16.6672 29.6232C15.5675 28.524 14.7185 27.1615 14.228 25.6172C14.9031 25.9542 15.6085 26.2275 16.3441 26.4353Z"
        fill="#EF7F0F"
      />
      <path
        d="M30.2176 45.9994L32.6929 46.4381C33.9225 46.6561 35.0301 47.2554 35.8761 48.1243C35.8961 48.1448 35.9168 48.1652 35.9319 48.1854L35.2715 49.0926H15.7411L15.1005 48.185C15.9509 47.2891 17.0758 46.6699 18.328 46.4464L20.8174 46.002C22.2858 45.7398 23.3552 44.4627 23.3552 42.971V32.2989C19.7087 31.4928 16.747 28.6715 15.8487 24.9202L11.1851 5.44336L25.5155 4.53613L39.8434 5.44336L35.1481 24.9335C34.2485 28.6678 31.3035 31.4772 27.676 32.2915V42.9678C27.676 44.4608 28.7474 45.7388 30.2176 45.9994Z"
        fill="#FFCF4D"
      />
      <path
        d="M39.8433 5.44346L40.2805 3.62891H10.7505L11.185 5.44346H39.8433Z"
        fill="#FFB629"
      />
      <path
        d="M35.9315 48.1855H15.1005C14.6073 48.7052 14.2061 49.3175 13.9263 50.0001H37.1043L37.0856 49.9556C36.8076 49.2905 36.413 48.6942 35.9315 48.1855Z"
        fill="#FFB629"
      />
      <path
        d="M26.4764 10.7338L27.4711 12.7494C27.6297 13.0708 27.9362 13.2935 28.2909 13.345L30.5152 13.6682C31.4083 13.798 31.7649 14.8956 31.1187 15.5254L29.5092 17.0943C29.2525 17.3445 29.1355 17.7048 29.196 18.0581L29.576 20.2733C29.7285 21.1627 28.7949 21.8411 27.9961 21.4211L26.0066 20.3752C25.6895 20.2084 25.3105 20.2084 24.9933 20.3752L23.0038 21.4211C22.205 21.8411 21.2714 21.1628 21.4239 20.2733L21.8039 18.0581C21.8645 17.7048 21.7474 17.3445 21.4907 17.0943L19.8813 15.5254C19.2351 14.8955 19.5916 13.798 20.4847 13.6682L22.709 13.345C23.0637 13.2934 23.3702 13.0708 23.5288 12.7494L24.5235 10.7338C24.923 9.92466 26.077 9.92466 26.4764 10.7338Z"
        fill="#FF9517"
      />
      <path
        d="M26.0066 18.5606C25.6894 18.3938 25.3104 18.3938 24.9932 18.5606L21.4079 20.4456C21.3938 21.2471 22.2575 21.8134 23.0038 21.4211L24.9932 20.3752C25.3104 20.2084 25.6894 20.2084 26.0066 20.3752L27.9961 21.4211C28.7424 21.8135 29.606 21.2471 29.592 20.4456L26.0066 18.5606Z"
        fill="#EF7F0F"
      />
    </svg>
  </div>
</template>
<style lang="scss" scoped>
.cup {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9rem;
  height: 9rem;
  border-radius: 50%;
  background-color: var(--color_secondary_lighter);
}
</style>
